import { getBridgeSdk } from "@swiggy-private/checkout-core";
import { STORAGE_TYPES } from "@swiggy-private/native-bridge";

type EmptiableType = string | number | boolean | undefined | object | Function;

/**
 * Checks whether given value is empty
 */
export function isEmpty(value: EmptiableType): boolean {
    if (value == null) {
        return true;
    }

    switch (typeof value) {
        case "string":
            return value.length === 0;
        case "number":
        case "boolean":
            return !value;
        case "undefined":
            return true;
        case "object":
            return Object.keys(value).length === 0;
        case "function":
            return false;
        default:
            return !value;
    }
}

export async function firstTimeUserExperienceHelper(key: string, maxCount: number): Promise<boolean> {
    const response = await getBridgeSdk().storage({
        type: STORAGE_TYPES.GET,
        data: {
            [key]: "",
        },
    });
    const currentCount = response?.data[key];
    if (!currentCount) {
        getBridgeSdk().storage({
            type: STORAGE_TYPES.SAVE,
            data: {
                [key]: "1",
            },
        });

        return true;
    } else {
        if (JSON.parse(currentCount) < maxCount) {
            getBridgeSdk().storage({
                type: STORAGE_TYPES.SAVE,
                data: {
                    [key]: JSON.stringify(Number(currentCount) + 1),
                },
            });
            return true;
        } else {
            return false;
        }
    }
}
